import { render, staticRenderFns } from "./UserItems.vue?vue&type=template&id=24663570&"
import script from "./UserItems.vue?vue&type=script&lang=js&"
export * from "./UserItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports